import { Modal, ModalSize, ModalType } from '@ukpostbox/frontend-framework';
import { useEffect, useState } from 'react';
import { useSite } from '../Providers/SiteInterfaceProvider';

function PDFViewerModal(props: ModalType) {
	const { pDFViewerDetails } = useSite();

	const [pdf, setPdf] = useState<any>({ url: pDFViewerDetails.uri });

	useEffect(() => {
		setPdf({ url: pDFViewerDetails.uri });
	}, [pDFViewerDetails]);

	return (
		<Modal title='PDF Viewer' isOpen={props.isOpen} closeCallback={props.closeCallback} modalSize={ModalSize.Large}>
			<object data={pdf.url} type='application/pdf' className='pdf-viewer' aria-label='File Preview' />
		</Modal>
	);
}

export default PDFViewerModal;
